import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
  import { EntityTypePropertyForm, PropertyDataType } from '@/entities/entityTypeProperty';
  import { OptionSet } from '@/entities/optionSet';
  import { ValidationError } from '@/entities/validation';
  import { InputField } from '@/ui/components/form';
  import { Icon } from '@/ui/components/icon/Icon';
  import PropertyFormatPicker from './PropertyFormatPicker.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'PropertyRow',
  props: {
    property: {
      type: Object as () => EntityTypePropertyForm,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    optionSets: {
      type: Array as () => OptionSet[],
      required: true,
    },
    optionSetsLoading: {
      type: Boolean,
    },
    errors: {
      type: Array as () => ValidationError[],
    },
    disabled: {
      type: Boolean,
    },
  },
  emits: [
    'update',
    'delete',
    'edit-option-set',
    'delete-option-set',
    'create-option-set',
    'load-option-sets',
    'add-property',
  ],
  setup(__props, { emit }) {

const props = __props;

  

  

  const optionSetName = computed(() => {
    if (!props.property.optionSetId) {
      return '';
    }

    const optionSet = props.optionSets.find(os => os.id === props.property.optionSetId);

    return optionSet?.name || '';
  });

  const updateLabel = (value: string) => {
    emit('update', { ...props.property, label: value });
  };

  const handleFormatSelect = (format: PropertyDataType) => {
    const updatedProperty = { ...props.property, dataType: format };

    if (format === PropertyDataType.Text) {
      updatedProperty.optionSetId = null;
      updatedProperty.allowMulti = false;
    }

    emit('update', updatedProperty);
  };

  const handleOptionSetSelect = (optionSetId: number) => {
    const updatedProperty = {
      ...props.property,
      dataType: PropertyDataType.Dropdown,
      optionSetId,
    };

    emit('update', updatedProperty);
  };

return { __sfc: true,props, emit, optionSetName, updateLabel, handleFormatSelect, handleOptionSetSelect, InputField, Icon, PropertyFormatPicker }
}

})